"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CW_STRATEGIST_TEMPLATES = exports.CW_STRATEGIST_TEMPLATES_MD = void 0;
exports.CW_STRATEGIST_TEMPLATES_MD = {
    'Course Selection': `* Discuss Course Selection and its role in the admission process\n
* Current inventory of academic history\n
* Discuss academic interests\n
* Discuss school offerings\n
* Create 4 year plan`,
    'Course Selection (continued)': `* Review academic progress\n
* Revisit 4 year-plan\n
* What's going well? What's not going well?`,
    Activities: `* Discuss current activities\n
* Explore current interests and goals\n
* Brainstorm potential activities`,
    'Activities (continued)': `* Continue to explore activities.\n
* Review progress of activity section\n
* What is going well? What isn't going well?\n
* Explore opportunities for leadership + impact`,
    Testing: `* Discuss role of testing in admissions\n
* Inventory of current testing\n
* To Test or not to Test?\n
* Create Testing Timeline`,
    'Testing (continued)': `* Review Testing Progress\n
* Revisit Testing Timeline\n
* Discuss changes to testing timeline based on progress`,
    'Major Research': `* Discuss the role of majors in admissions\n
* Inventory of current interests in relation to majors\n
* Discuss major research\n
* Review Research Tools`,
    'Summer Planning': `* Discuss Summer options\n
* Explore potential options\n
* Create Summer plan`,
    'College Research': `* Discuss college selection and its role in admissions\n
* Discuss college preferences\n
* Review research tools\n
* Create first college list`,
    'College Research (continued)': `* Review research.\n
* Provide an updated list of colleges to research based off initial findings`,
    'Narrow the College List': `* Discuss current list\n
* Discuss strategies and tips to narrowing the list\n
* Discuss the 'balance' of the list, and identify gaps`,
    'Finalizing the College List': `* Finalize the college list\n
* Parent discussion\n
* Discuss demonstrated interest\n
* Discuss next steps now that list is finalized`,
    'Essay Brainstorming': `* Review brainstorming exercise\n
* Outline Essay`,
    'College Visits': `* Discuss attending college fairs\n
* Discuss college visits and opportunities to visit colleges in conjunction with family travel`,
    'Letters of Recommendation': `* Discuss letters of recommendation and their role in the admissions process\n
* Identify 1-2 recommenders and discuss\n
* Evaluate current list and recommendation requirements`,
    'Financial Aid': `* Share out information on financial aid deadlines.\n
* Remind families to submit FAFSA and CSS Profile`,
    'Senior Season - Deadline Selection': `* Confirm which school student is applying Early Decision\n
* Confirm which deadlines we are applying to\n
* Confirm EA/ED pathways and (ideally) major selection for ED school.`,
    'Senior Season - Supplement Essays': `* Brainstorm and outline supplement essays for the colleges listed`,
    'Senior Season - Submit Applications': `* Walk through how to submit\n
* Submit first application`,
    'Senior Season - Interviews': `* Share out information on interview process. If you would like additional support, we can discuss what that would look like.`,
    'Senior Season - Submit materials': `* Confirm which colleges need transcripts and method for sending.\n
* Discuss what test scores need to be sent to each school on the list.\n
* Check in on the status of letters of recommendation.`,
    'Time management & student habits': `* Review organizational habits, time management, study habits`,
    'Interview Prep': `* Discuss the purpose of the interview in the application process\n
* Tips and items to focus on for up to five schools the student will interview at`,
};
const convertCWTemplates = (source) => {
    const result = {};
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            const contentLines = source[key].split('\n').filter((line) => line.trim() !== '');
            const convertedContent = contentLines.map((line, index) => ({
                listStart: index + 1,
                type: 'p',
                children: [{ text: line.replace('*', '').trim() }],
                listStyleType: 'disc',
                indent: 1,
            }));
            result[key] = convertedContent;
        }
    }
    return result;
};
exports.CW_STRATEGIST_TEMPLATES = convertCWTemplates(exports.CW_STRATEGIST_TEMPLATES_MD);
//# sourceMappingURL=cw-strategist.js.map